import React from "react"
import {Routes, useLocation} from "react-router-dom"
import RootDialog from "../../anwendungskonfigurator/components/RootComponents/RootDialog.jsx"
import RootDrawer from "../../anwendungskonfigurator/components/RootComponents/RootDrawer.jsx"
import RouteErrorBoundary from "../components/RouteErrorBoundary.jsx"

// Inhaltsbereich inkl. Error-Boundary; per useLocation wird die Boundary bei
// jedem Routenwechsel zurueckgesetzt (resetKey).
const MainContent = ({appRoutes, dialogContainer, drawerContainer}) => {
    const location = useLocation()
    return (
        <>
            <RouteErrorBoundary resetKey={location.pathname}>
                <Routes>{appRoutes}</Routes>
            </RouteErrorBoundary>
            {dialogContainer.map(item => <RootDialog container={item} key={item.id} />)}
            <RootDrawer drawerContainer={drawerContainer} />
        </>
    )
}

export default MainContent
